import serviceSalesModule from "./serviceSalesModule";
import serviceSalesSaga from "./redux/serviceSalesSaga";
import serviceSalesReducer from "./redux/serviceSalesReducer";

export default {
  Component: serviceSalesModule,
  moduleName: "serviceSales",
  saga: serviceSalesSaga(),
  reducer: serviceSalesReducer
};
